// extracted by mini-css-extract-plugin
var _1 = "icon__jvqiS";
export { _1 as "icon" }
